/* eslint-disable no-empty */
import { newError } from '../errors';
import * as actionTypes from '../../constants/actions';
import fetch from '../../api/lti/fetch';

// Fetch classRoom instructors
const fetchProvidersStart = () => ({
  type: actionTypes.LTI_FETCH_PROVIDERS,
  status: 'started',
});

const fetchProvidersSuccess = (providers, dispatch) => {
  dispatch({
    type: actionTypes.LTI_FETCH_PROVIDERS,
    status: 'success',
    providers,
  });
};

const fetchProvidersError = (error, dispatch) => {
  dispatch(newError(error, 'fetchProviders'));
  dispatch({
    type: actionTypes.LTI_FETCH_PROVIDERS,
    status: 'error',
    error: Object.assign({}, error),
  });
};

const fetchProviders = () => async (dispatch, getState) => {
  if (!getState().user.isLogged) {
    const err = { message: 'You need to login first' };
    return fetchProvidersError(err, dispatch);
  }

  dispatch(fetchProvidersStart());

  try {
    const providers = await fetch();
    return fetchProvidersSuccess(providers, dispatch);
  } catch (error) {
    return fetchProvidersError(error, dispatch);
  }
};

export default fetchProviders;
